export const logInRedirectUrl = 'signin-redirect';
export const loggedOutUrl = 'logged-out';
export const silentTokenRefreshUrl = 'token-refresh';
